import { Component, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { LoadingComponent } from './features/loading/loading.component';
import { ChatService } from './core/services/chat.service';
import { AdministradorChatsComponent } from './features/administrador-chats/administrador-chats.component';
import { MatBadge } from '@angular/material/badge';
import { AuthService } from './core/services/auth.service';
import { hasAllPermission, hasPermission, hasSomePermission } from './core/helpers/utilities';
import {
  permisosConfiguracionAgente,
  permisosCumplimientoMeta,
  permisosEstatusSeguimientoNegocio,
  permisosExperienciaAgente,
  permisosImpuestoProducto,
  permisosMetaActivacion,
  permisosNegocio,
  permisosPagoComisionAgenteLog,
  permisosSaldoAgente,
  permisosTipoSeguimientoNegocio,
  permisosUnidadMedida,
} from './core/helpers/permissions.data';
import { Subscription } from 'rxjs';
import { RoleService } from './core/services/role.service';
import { NotificacionService } from './core/services/notificacion.service';
import { SeguridadService } from './core/services/seguridad.service';
import { SaldoAgenteService } from './core/services/saldo-agente.service';
import { SeguimientoProgramadoNegocio } from './shared/models/seguimientoProgramadoNegocio';
import { TotalSeguimientoProspectoService } from './core/services/total-seguimiento-prospecto.service';
import { ChatComponent } from './features/administrador-chats/chat/chat.component';
import { FieldForm, FormDialogGenericoComponent } from './shared/form-dialog-generico/form-dialog-generico.component';
import { Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from './core/services/user.service';
import { GenericoService } from './core/services/generico.service';
import { ValidationMessagesService } from './core/services/validation-messages.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatExpansionModule,
    RouterLink,
    CommonModule,
    MatCardModule,
    LoadingComponent,
    AdministradorChatsComponent,
    MatBadge,
    ChatComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {

  @ViewChild(AdministradorChatsComponent) administradorChatsComponent!: AdministradorChatsComponent
  @ViewChild('drawerAdminChats') drawerAdminChats!: MatDrawer;
  @ViewChild('contentMatDrawer', { read: ViewContainerRef }) contentMatDrawer!: ViewContainerRef;
  title = 'linnegocios-back';
  public viewChats: any = [];


  isMobileView!: boolean;
  isSidenavOpen = false;
  isAuthenticated: boolean = false;
  public notificacion = 0;
  userAccess!: any;
  roles!: string;
  usuario!: string;

  private permissionSub?: Subscription = undefined;
  private chatsCountSub!: Subscription;
  private chatSubscriptions = new Subscription();
  totalChats!: number;
  chatsAbiertos: any;
  public saldoAgente = 0.0;

  totalSeguimientoProgramadoNegocio = 0;
  seguimientoProgramadoMenor: any = null;
  public seguimientoProgramadoNegocioList: SeguimientoProgramadoNegocio[] = [];
  userInfo!: any;


  constructor(
    private router: Router,
    private chatService: ChatService,
    private authService: AuthService,
    private roleService: RoleService,
    private notificacionService: NotificacionService,
    public seguridadService: SeguridadService,
    private saldoAgenteService: SaldoAgenteService,
    private totalSeguimientoProspectoService: TotalSeguimientoProspectoService,
    private userService: UserService,
    private genericoService: GenericoService,
    private validationMessagesService: ValidationMessagesService,
    private dialog: MatDialog,
  ) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileView = event.target.innerWidth <= 768;
  }

  data: any = {};

  ngOnInit() {
    this.isMobileView = window.innerWidth <= 768;
    this.isSidenavOpen = !this.isSidenavOpen && this.isMobileView

    this.isAuthenticated = this.authService.getSession();
    if (this.isAuthenticated) {
      this.roleService.setPermissions();
      this.initPermissionSubscription();
      this.userAccess = this.authService.getLocalStorage();
      this.userInfo = this.authService.getUserInfo();
      this.usuario = `${this.userInfo.nombre} ${this.userInfo.apeidoPaterno}`;
      this.roles = this.authService.getRoles();
      this.getChatsCount();
      this.getSaldoAgente();
      this.getListAndCountSeguimientoProgramdo();
      this.observableSeguimientoProgramado();
      this.getSelectedChats();

    }
  }

  getSelectedChats(): void {
    this.viewChats = [];
    this.chatSubscriptions.add(this.chatService.returnSelectedChats().subscribe(response => {
      this.viewChats = response;
      // this.selectedChat.emit(this.viewChats)


      // const componentRef: ComponentRef<ChatComponent> = this.contentMatDrawer.createComponent(ChatComponent);
      // componentRef.instance.chat = this.viewChats; // Asigna los datos al componente
      //
      // // Aplicar estilos de posición
      // const chatElement = componentRef.location.nativeElement;
      // chatElement.style.position = 'absolute'; // Asegúrate de que el contenedor tenga posición relativa
      // chatElement.style.right = `${this.positionRightChat}px`; // Posición aleatoria a la derecha
      //
      // this.positionRightChat+=340;
    }));
  }

  getChatsCount() {
    this.chatsCountSub = this.chatService.getChatsCount().subscribe(chats => this.totalChats = chats.length);
    this.chatSubscriptions.add(this.chatService.alerts$.subscribe(chat => {
      this.notificacionService.show('Chat Linnegocios', {
        body: `Nuevo mensaje de ${chat.usuario?.nombre || 'un usuario'}${chat.negocio?.nombre ? ' · ' + chat.negocio.nombre : ''}`,
        tag: 'chat-' + chat.idChat + '-' + chat.lastIncomingMessageId,
        icon: '../assets/svg/icono-linnegocios.svg'
      }, location.origin);
    }));
  }
  async enableChatNotifications(): Promise<void> {
    const permission = await this.notificacionService.requestPermission();
    if (permission === 'granted' && this.totalChats > 0) this.notificacionService.show('Chat Linnegocios', {body: `Tienes ${this.totalChats} conversaciones pendientes.`, tag: 'chat-pending-summary'});
  }
  trackChat(_index: number, chat: any): any { return chat.idChat; }

  getSaldoAgente() {
    this.saldoAgenteService.getMiSaldo().subscribe(({ saldo }) => {
      this.saldoAgente = saldo || 0.0;
    });
  }

  ngOnDestroy(): void {
    this.chatSubscriptions.unsubscribe();
    this.chatService.stopSession();
    if (this.permissionSub) {
      this.permissionSub.unsubscribe();
      this.permissionSub = undefined;
    }

    if (this.chatsCountSub) {
      this.chatsCountSub.unsubscribe();
    }
  }

  private initPermissionSubscription(): void {
    this.permissionSub = this.roleService
      .getPermissionSubject()
      .subscribe(() => {
      });
  }


  async logout() {

    const isConfirmed = await this.genericoService.confirmDialog(
      '¿Está seguro de cerrar sesión?',
    );
    if (!isConfirmed) {
      return;
    }

    this.logoutConfirm();

  }

  logoutConfirm() {
    this.chatsCountSub?.unsubscribe(); this.chatSubscriptions.unsubscribe(); this.chatService.stopSession();
    this.authService.closeSession();
    localStorage.removeItem('user_info');
    const token = this.authService.getSession();
    if (!token) {
      this.router.navigate(['/login'])
      // Esto recargará la página
      window.location.reload();
      // Recargar la página si es necesario
      this.isAuthenticated = this.authService.getSession();
    }
  }

  changeCredentials() {

    const fieldForms: FieldForm[] = [
      {
        form: 'changeCredenciales',
        validatorGroup: { validators: this.validationMessagesService.passwordsIguales('nuevaContrasena', 'confirmarNuevaContrasena') },
        fields: [
          [
            {
              name: 'username',
              label: 'Username',
              value: 'username',
              type: 'text',
              visibility: true,
            },
          ],
          [
            {
              name: 'contrasenaActual',
              label: 'Contraseña actual',
              value: 'contrasenaActual',
              type: 'password',
              validation: Validators.required,
            },
          ],
          [
            {
              name: 'nuevaContrasena',
              label: 'Contraseña nueva',
              value: 'nuevaContrasena',
              type: 'password',
              validation: Validators.compose([Validators.required, this.validationMessagesService.passwordComplejo(8)]),
            },
          ],
          [
            {
              name: 'confirmarNuevaContrasena',
              label: 'Confirmar contraseña nueva',
              value: 'confirmarNuevaContrasena',
              type: 'password',
              validation: Validators.compose([
                Validators.required,
                this.validationMessagesService.passwordComplejo(8),
                this.validationMessagesService.passwordsIguales('nuevaContrasena', 'confirmarNuevaContrasena'),
              ]),
            },
          ],
        ],
      },
    ]
    this.data = {
      username: this.userInfo.username,
    }

    let titleDialog = 'Cambiar contraseña'

    const dialogSize = this.genericoService.getDialogSize();
    const dialogRef = this.dialog.open(FormDialogGenericoComponent, {
      data: {
        titleDialog: titleDialog,
        fieldForms,
        data: this.data,
      },
      disableClose: true,
      minWidth: dialogSize.width,
    });

    dialogRef.componentInstance.submitForm.subscribe((result: any) => {

      this.userService.updateCredentials(result.changeCredenciales).subscribe((response: any) => {
        if (response.message) {
          this.genericoService.openSnackBar(
            response.message,
            'Aceptar',
            'snack-bar-success', () => {
            });
          this.logoutConfirm();
        }
        setTimeout(() => {
          location.reload();
        }, 3500);
      });
    });
  }

  toggleSidenav() {
    this.isSidenavOpen = !this.isSidenavOpen;
  }

  chatSeleccionados(chats: any) {
    this.chatsAbiertos = chats;
  }

  observableSeguimientoProgramado() {
    this.totalSeguimientoProspectoService.getListAndCountSeguimientoProgramadoObservable.subscribe(response => {
      this.seguimientoProgramadoNegocioList = response.data;
      this.totalSeguimientoProgramadoNegocio = response.count;

      if (this.totalSeguimientoProgramadoNegocio > 0) {
        this.seguimientoProgramadoMenor = this.seguimientoProgramadoNegocioList.reduce((menor, fecha) => {
          if (menor.fechaProgramada > fecha.fechaProgramada) {
            menor.fechaProgramada = fecha.fechaProgramada;
          }
          return menor;
        });
      }
    });
  }

  getListAndCountSeguimientoProgramdo() {
    this.totalSeguimientoProspectoService.getSeguimientoProgramadoNegocio();
  }

  closeAdminChat(event: any) {
    this.drawerAdminChats.close();
  }


  protected readonly hasPermission = hasPermission;
  protected readonly permisosSaldoAgente = permisosSaldoAgente;
  protected readonly permisosPagoComisionAgenteLog = permisosPagoComisionAgenteLog;
  protected readonly permisosCumplimientoMeta = permisosCumplimientoMeta;
  protected readonly permisosConfiguracionAgente = permisosConfiguracionAgente;
  protected readonly hasAllPermission = hasAllPermission;
  protected readonly hasSomePermission = hasSomePermission;
  protected readonly permisosNegocio = permisosNegocio;
  protected readonly permisosTipoSeguimientoNegocio = permisosTipoSeguimientoNegocio;
  protected readonly permisosEstatusSeguimientoNegocio = permisosEstatusSeguimientoNegocio;
  protected readonly permisosUnidadMedida = permisosUnidadMedida;
  protected readonly permisosMetaActivacion = permisosMetaActivacion;
  protected readonly permisosExperienciaAgente = permisosExperienciaAgente;
  protected readonly permisosImpuestoProducto = permisosImpuestoProducto;
}
